export default "__VITE_ASSET__lD_5XLWF__"